const stages = Object.freeze({
  SUBMIT_PRE_PROCESSING: Symbol('submit-pre-processing'),
  SUBMIT_ACTIONS_GENERATION: Symbol('submit-actions-generation'),
  SUBMIT_TRAITS_GENERATION: Symbol('submit-traits-generation'),
});

export default stages;
